import React, { Component } from 'react';
import { InputGroup } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import './assets/styles/search.scss';

import searchIcon from './assets/images/search.png';

class SearchField extends Component {
  // getValue and setValue are necessary to be implemented
  getValue() {
    return ReactDOM.findDOMNode(this).value;
  }

  setValue(value) {
    ReactDOM.findDOMNode(this).value = value;
  }

  render() {
    const {
      isLoading = false,
      defaultValue = '',
      placeholder = '',
      search,
      onChange,
      style = {},
    } = this.props;

    return (
      <div className="custom-search" style={style}>
        <InputGroup className={'search-input-group'}>
          <input
            id="clear-btn-search"
            className={`form-control ${
              isLoading ? 'input-loading' : ''
            } clear-btn-search`}
            type="text"
            value={defaultValue}
            placeholder={placeholder}
            onKeyUp={search}
            onChange={({ target: { value = '' } = {} }) => onChange(value)}
          />
          <InputGroup.Addon className={'input-group-btn'}>
            <img src={searchIcon} alt="search" />
          </InputGroup.Addon>
        </InputGroup>
      </div>
    );
  }
}

export { SearchField };
